/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2025-01-29",
    versionChannel: "nightly",
    buildDate: "2025-01-29T00:06:06.654Z",
    commitHash: "6ba533db6c1cda5043961e0d9b384d4481f2a36d",
};
